import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/recordManage',
    meta: { title: '收发油管理' },
    component: Layout,
    children: [
      {
        path: 'list',
        meta: { activeMenu: '/recordManage' },
        component: () => import('@/views/recordmanage/RecordManage.vue')
      },
      {
        path: 'add',
        meta: {
          title: '新增收发油',
          activeMenu: '/recordManage'
        },
        component: () => import('@/views/recordmanage/RecordManageAdd.vue')
      },
      {
        path: 'edit',
        meta: {
          title: '编辑收发油',
          activeMenu: '/recordManage'
        },
        component: () => import('@/views/recordmanage/RecordManageAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '收发油详情',
          activeMenu: '/recordManage'
        },
        component: () => import('@/views/recordmanage/RecordManageDetail.vue')
      }

    ]
  },
  {
    path: '/carrecord',
    meta: { title: '车辆进厂记录' },
    component: Layout,
    redirect: '/carrecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '车辆进厂记录', activeMenu: '/carrecord' },
        component: () => import('@/views/carrecord/CarRecord.vue')
      }
    ]
  },
  {
    path: '/storagerecord',
    meta: { title: '储运信息' },
    component: Layout,
    redirect: '/storagerecord/list',
    children: [
      {
        path: 'list',
        meta: { title: '储运信息', activeMenu: '/storagerecord' },
        component: () => import('@/views/storage/StorageManage.vue')
      },
      {
        path: 'deal',
        meta: { title: '确认信息', activeMenu: '/storagerecord' },
        component: () => import('@/views/storage/StorageManageAdd.vue')
      }
    ]
  },
  {
    path: '/appearance',
    meta: { title: '车辆出场' },
    component: Layout,
    redirect: '/appearance/list',
    children: [
      {
        path: 'list',
        meta: { title: '车辆出场', activeMenu: '/appearance' },
        component: () => import('@/views/appearance/Appearance.vue')
      }
    ]
  }
]
